import { createTheme } from "@mui/material/styles";

let theme = createTheme({
	palette: {
		primary: {
			main: "#034F8B",
		},
		secondary: {
			main: "#ff7629",
			dark: "#f55a00",
			contrastText: "#ffffff",
		},
		info: {
			main: "#ffffff",
			dark: "#e6e6e6",
			contrastText: "#000000",
		},
	},
});

theme = createTheme(theme, {
	components: {
		MuiTypography: {
			styleOverrides: {
				body1: {
					fontSize: "15px",
					lineHeight: "20px",
					color: "#767676",
				},
				caption: {
					lineHeight: "16px",
				},
				h1: {
					fontSize: "70px",
					lineHeight: "76px",
					[theme.breakpoints.down("lg")]: {
						fontSize: "56px",
						lineHeight: "62px",
					},
					[theme.breakpoints.down("md")]: {
						fontSize: "46px",
						lineHeight: "52px",
					},
					[theme.breakpoints.down("sm")]: {
						fontSize: "30px",
						lineHeight: "36px",
					},
				},
				h2: {
					fontSize: "40px",
					lineHeight: "46px",
					[theme.breakpoints.down("lg")]: {
						fontSize: "26px",
						lineHeight: "32px",
					},
					[theme.breakpoints.down("md")]: {
						fontSize: "20px",
						lineHeight: "26px",
					},
					[theme.breakpoints.down("sm")]: {
						fontSize: "18px",
						lineHeight: "24px",
					},
				},
				h3: {
					fontSize: "22px",
					lineHeight: "26px",
					color: "#575757",
					[theme.breakpoints.down("sm")]: {
						fontSize: "17px",
						lineHeight: "22px",
					},
				},
				h4: {
					fontSize: "18px",
					lineHeight: "22px",
					color: "#fff",
					[theme.breakpoints.down("sm")]: {
						fontSize: "15px",
						lineHeight: "20px",
					},
				},
				h5: {
					fontSize: "16px",
					lineHeight: "20px",
				},
			},
		},
		MuiAlert: {
			styleOverrides: {
				root: {
					fontSize: "18px",
					lineHeight: "22px",
					alignItems: "center",
					padding: "11px 15px 10px",
					[theme.breakpoints.down("md")]: {
						fontSize: "16px",
						lineHeight: "22px",
						padding: "8px 10px",
					},
					[theme.breakpoints.down("sm")]: {
						fontSize: "14px",
						lineHeight: "18px",
						padding: "6px 8px",
					},
					"&.MuiAlert-filledInfo": {
						backgroundColor: "#F7F7F8",
						color: "#767676",
						border: "1px solid #DDDDDD",
					},
					"& .MuiAlert-message": {
						padding: 0,
					},
				},
			},
		},
		MuiTableContainer: {
			styleOverrides: {
				root: {
					overflow: "visible",
					boxShadow: "0px 0px 6px 2px rgba(0, 0, 0, 0.08);",
					".table-responsive": {
						overflow: "auto",
						width: "100%",
					},
				},
			},
		},

		MuiTable: {
			styleOverrides: {
				root: {
					".MuiCheckbox-root": {
						".MuiAvatar-root": {
							height: 18,
							width: 18,
						},
					},
					".MuiTableCell-root": { borderBottom: "none" },
					".MuiTableHead-root": {
						".MuiTableCell-head": {
							whiteSpace: "nowrap",
							".th-wrapper": {
								display: "flex",
								alignItems: "center",
								".MuiTypography-caption": {
									whiteSpace: "nowrap",
									fontSize: "15px",
									lineHeight: "20px",
								},
								".MuiButtonBase-root": {
									".MuiAvatar-root": { height: 15, width: 15 },
								},
							},
						},
					},
					".MuiTableBody-root": {
						".MuiTableRow-root": {
							".MuiTableCell-body": {
								height: 45,
								padding: "2px 10px",
								color: "#767676",
								fontSize: "15px",
								lineHeight: "20px",
							},
						},
					},
				},
			},
		},
		MuiBreadcrumbs: {
			styleOverrides: {
				root: {
					".MuiLink-root": {
						color: "#767676",
						fontSize: "14px",
						lineHeight: "18px",
					},
					".MuiBreadcrumbs-separator": { color: "#BABABA" },
					".MuiTypography-body1": {
						color: "#BABABA",
						fontSize: "14px",
						lineHeight: "18px",
					},
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none",
					whiteSpace: "nowrap",
				},
			},
		},
		MuiFormControl: {
			styleOverrides: {
				root: {
					width: "100%",
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: { fontSize: "15px", lineHeight: "20px" },
			},
		},
		MuiFormControlLabel: {
			styleOverrides: {
				root: {
					marginLeft: "-9px",
				},
			},
		},
		MuiTablePagination: {
			styleOverrides: {
				root: {
					fontSize: "15px",
					lineHeight: "20px",
					color: "#767676",
					".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
						{
							fontSize: "15px",
							lineHeight: "20px",
						},
				},
			},
		},
		MuiAppBar: {
			styleOverrides: {
				root: {
					backgroundColor: "#ffffff",
					boxShadow: "0px 0px 6px 2px rgba(0, 0, 0, 0.08)",
					".MuiToolbar-root": {
						[theme.breakpoints.up("md")]: { minHeight: "75px" },
						[theme.breakpoints.down("md")]: {
							paddingLeft: "20px",
							paddingRight: "20px",
						},
						[theme.breakpoints.down("sm")]: {
							minHeight: "65px",
							paddingLeft: "16px",
							paddingRight: "16px",
						},
					},
				},
			},
		},
		MuiList: {
			styleOverrides: {
				root: {
					color: "#767676",
					paddingTop: 0,
					paddingBottom: 0,
					boxShadow: "0px 0px 7px 2px rgba(0, 0, 0, 0.2)",
					".MuiMenuItem-root": {
						fontSize: "15px",
						lineHeight: "18px",
						padding: "12px 15px",
						minHeight: "auto",
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					fontSize: "15px",
					input: {
						padding: "11px 14px",
						height: 45,
						boxSizing: "border-box",
						"&::placeholder": { color: "#BABABA" },
					},
					".MuiInputAdornment-positionEnd": {
						".MuiAvatar-root": { height: 20, width: 20 },
					},
					fieldset: { borderColor: "#dddddd" },
				},
			},
		},
	},
});

export default theme;
